import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  TableBody,
  TableCell,
  Stack,
  TableContainer,
  TableHead,
  Dialog,
  Breadcrumbs,
  MenuItem,
  TablePagination,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  Typography,
  TableRow,
  Paper,
  Container,
} from "@mui/material";
import Iconify from "../../components/iconify";
import { hasPermission, PERMISSIONS } from "../../utils/hasPermission";
import { HomeRounded } from "@mui/icons-material";
import ApiCall from "../../utils/apicall";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  // { id: "company", label: "Company Name", alignRight: false },
  // { id: "vendor_name", label: "Vendor Name", alignRight: false },
  { id: "address", label: "Address", alignRight: false },
  { id: "phone", label: "Phone", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
];

// Utility function to format phone number as (123) 456-7890
function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = "+1 ";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}
function formatfaxNumber(faxNumberString) {
  var cleaned = ("" + faxNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return ["+1", "-", match[2], "-", match[3], "-", match[4]].join("");
  }
  return null;
}

export default function PurchaseOrder() {
  const [page, setPage] = useState(0);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { loginUser } = useSelector((state) => state.userSlice);
  const { permissions: userPermissions } = loginUser.decodedToken;
  const canAddPurchaseOrder = hasPermission(
    userPermissions,
    PERMISSIONS.ADD_PURCHASE
  );
  const canEditPurchaseOrder = hasPermission(
    userPermissions,
    PERMISSIONS.EDIT_PURCHASE
  );
  const canDeletePurchaseOrder = hasPermission(
    userPermissions,
    PERMISSIONS.DELETE_PURCHASE
  );
  const canViewDetails = hasPermission(
    userPermissions,
    PERMISSIONS.VIEW_PURCHASEDETAIS
  );

  const navigate = useNavigate();

  const fetchPurchaseOrder = async () => {
    try {
      const response = await ApiCall.get("/purchaseorder");
      const purchaseOrders = response.data.data.purchaseOrders.filter(
        (order) => order.deleted_at === null
      );
      if (response) {
        setSearchResults(response.data.data.purchaseOrders);
        setPurchaseOrders(purchaseOrders);
      }
    } catch (error) {
      // Handle any errors here
      console.log(error, "err");
    }
  };

  useEffect(() => {
    const fetchPurchaseOrders = async () => {
      try {
        const response = await ApiCall.get("/purchaseorder");
        const purchaseOrders = response.data.data.purchaseOrders.filter(
          (order) => order.deleted_at === null
        );
        if (response) {
          setSearchResults(response.data.data.purchaseOrders);
          setPurchaseOrders(purchaseOrders);
        }
      } catch (error) {
        // Handle any errors here
        console.log(error, "err");
      }
    };
    fetchPurchaseOrders();
  }, []);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };
  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await ApiCall.get("/purchaseorder", {
          params: {
            page: page + 1,
          },
        });
        setPurchaseOrders(response.data.data.purchaseOrders);
      } catch (error) {
        console.log("err", error);
      }
    };
    fetchPage();
  }, [page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleDelete = async (id) => {
    try {
      const response = await ApiCall.delete(`/purchaseorder/${id}`);

      if (response) {
        fetchPurchaseOrder();
        toast("PurchaseOrder Deleted Successfully!");
        // console.log("Purchase Order deleted successfully");
        setPurchaseOrders((PurchaseOrder) =>
          PurchaseOrder.filter((order) => order.id !== id)
        );
      } else {
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleEdit = (id) => {
    navigate(`/purchaseorderform/${id}`);
  };
  const handleDetails = (id) => {
    navigate(`/Details/${id}`);
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - purchaseOrders.length)
      : 0;
  const isNotFound = !searchResults.length && !!filterName;

  const handleSearch = async () => {
    try {
      const response = await ApiCall.get("/purchaseorder", {
        params: {
          vendor_name: filterName,
        },
      });
      setSearchResults(response.data.data.purchaseOrders);
    } catch (error) {}
  };
  useEffect(() => {
    const handleSearchs = async () => {
      try {
        const response = await ApiCall.get("/purchaseorder", {
          params: {
            vendor_name: filterName,
          },
        });
        setSearchResults(response.data.data.purchaseOrders);
      } catch (error) {}
    };
    handleSearchs();
  }, [filterName]);

  const handleRfi = () => {
    // Codex F2 fix 2026-05-07: legacy /rfi-form route was deleted in the
    // 2026-05-05 Phase-5 cleanup (superseded by /rfis canonical surface
    // shipped 2026-05-02 PR #21). Navigate users to the AISC §1.6.0 RFI
    // create flow instead. Belt-and-suspenders compat redirect lives in
    // routes.js for any external bookmark of the old URL.
    navigate(`/rfis/new`);
  };

  return (
    <div>
      <Helmet>
        <title>Purchase Orders | SFM</title>
      </Helmet>
      <div>
        <Container>
          <PageHeader
            breadcrumbs={[{ label: "Purchase Orders" }]}
            title="Purchase Orders"
            action={<><Button
              onClick={() => navigate("/rfis")}
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              
            >
              RFI Response
            </Button>
            {canAddPurchaseOrder && (
              <Button
                onClick={() => navigate("/purchaseorderform")}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                New Purchase Order
              </Button>
            )}</>}
            guide={{
              why: "Buy material and services on the record — with AISC order-review and traceability terms attached — so what arrives can be traced to the order.",
              who: "Purchasing and the QM, who set order-review and traceability terms.",
              what: "Your purchase orders to vendors, each with line items and material-traceability terms.",
              how: "Create a PO, add line items, pick the approved vendor, and issue it.",
              when: "When you need to buy material, consumables, or services for a job.",
              standard: "AISC §1.5.0",
            }}
          />

          <TableContainer component={Paper}>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <TextField
                label="Search purchase orders..."
                variant="outlined"
                margin="normal"
                value={filterName}
                onChange={handleFilterByName}
                onKeyDown={handleEnterKeyPress}
              />
              <TablePagination
                rowsPerPageOptions={[10, 25]}
                component="div"
                count={purchaseOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
            <SmartTable tableId="purchase-orders" lockedColumns={["Company"]}>
              <TableHead>
                <TableRow>
                  <TableCell>Company</TableCell>
                  <TableCell>Vendor</TableCell>
                  {/* <TableCell>Assign To</TableCell> */}
                  {TABLE_HEAD.map((column) => (
                    <TableCell key={column.id}>{column.label}</TableCell>
                  ))}
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(searchResults) &&
                  searchResults
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((order) => (
                      <TableRow key={order.id}>
                        <TableCell>{order.company.name}</TableCell>
                        <TableCell>{order.vendor.vendor_name}</TableCell>
                        {/* <TableCell>
                          {order.firstName && order.firstName.firstName
                            ? order.firstName.firstName
                            : ""}
                        </TableCell> */}

                        {/* <TableCell>{order.vendors.vendor_name}</TableCell> */}
                        {TABLE_HEAD.map((column) => (
                          <TableCell key={column.id}>
                            {column.id === "phone"
                              ? formatPhoneNumber(order[column.id])
                              : column.id === "fax"
                              ? formatfaxNumber(order[column.id])
                              : column.id === "status"
                              ? order[column.id]
                                  ? order[column.id].charAt(0).toUpperCase() + order[column.id].slice(1).toLowerCase()
                                  : "—"
                              : order[column.id]}
                          </TableCell>
                        ))}
                        <TableCell align="right" style={{ display: "flex" }}>
                          {canEditPurchaseOrder && (
                            <MenuItem
                              variant="contained"
                              onClick={() => handleEdit(order.id)}
                            >
                              <Iconify icon={"eva:edit-fill"} />
                            </MenuItem>
                          )}
                          {canDeletePurchaseOrder && (
                            <MenuItem
                              sx={{ color: "error.main" }}
                              onClick={() => setSelectedItem(order)}
                            >
                              <Iconify icon={"eva:trash-2-outline"} />
                            </MenuItem>
                          )}
                          {canViewDetails && (
                            <MenuItem
                              sx={{ color: "error.main" }}
                              onClick={() => handleDetails(order.id)}
                            >
                              <Iconify icon={"eva:info-outline"} />
                            </MenuItem>
                          )}
                          {canViewDetails && (
                            <MenuItem
                              sx={{ color: "error.main" }}
                              onClick={() => handleRfi()}
                            >
                              <Iconify icon={"bx:rfid"} />
                            </MenuItem>
                          )}
                        </TableCell>
                        <Dialog
                          open={selectedItem !== null}
                          onClose={() => setSelectedItem(null)}
                        >
                          <DialogTitle>Delete Purchase Order</DialogTitle>
                          <DialogContent>
                            <Typography>
                              Are you sure you want to delete Purchase Order ?{" "}
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setSelectedItem(null)}>
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                handleDelete(selectedItem.id);
                                setSelectedItem(null);
                              }}
                              sx={{ color: "error.main" }}
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </TableRow>
                    ))}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={4} />
                  </TableRow>
                )}
              </TableBody>
              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </SmartTable>
          </TableContainer>
        </Container>
      </div>
    </div>
  );
}
